import React from 'react';
import AttemptFilesModal from 'components/@common/Modals/AttemptFilesModal';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import AttachmentIcon from '@mui/icons-material/Attachment';
import GetAppIcon from '@mui/icons-material/GetApp';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import ImageIcon from '@mui/icons-material/Image';
import MovieIcon from '@mui/icons-material/Movie';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { makeStyles } from '@mui/styles';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { translate } from 'translations/translator';
import { MIME_TYPE as MimeType } from 'types/enums';

interface AttemptFileProps {
  files: any[];
}

const MIME_TYPE_ICON_MAPPING = {
  audio: GraphicEqIcon,
  video: MovieIcon,
  image: ImageIcon
};

const getFileIcon = mimeType => {
  if (mimeType === MimeType.APPLICATION_PDF) return PictureAsPdfIcon;
  const [type] = mimeType.split('/');
  return MIME_TYPE_ICON_MAPPING[type] ?? AttachmentIcon;
};

const getTranslation = (key, options?) => translate('assignmentTracker', key, options);

const AttemptFiles: React.FC<AttemptFileProps> = ({ files }) => {
  const [, { openModal }] = useModal();
  const theme = useTheme();
  const classes = useStyles(theme)();

  const handleFilesClick = e => {
    const file = files.find(file => file.id === Number(e.currentTarget.value));

    if (!file) return;

    openModal({
      Title: undefined,
      titleText: getTranslation('attemptFiles'),
      body: <AttemptFilesModal files={[file]} />
      // options: {
      //   classes: { titleVariant: 'h6' }
      // }
    });
  };

  return (
    <Box p={3} mb={2}>
      <Typography variant="h4" className={classes.header}>
        {getTranslation('attemptFiles')}
      </Typography>
      {files.map(file => {
        const FileIcon = getFileIcon(file.mimeType);
        return (
          <Box key={file.id} display="flex" alignItems="center" py={1}>
            <Box display="flex" alignItems="center" mr={1}>
              <FileIcon />
            </Box>
            <Typography>{file.title}</Typography>
            <Box ml="auto" border={1} borderRadius={8}>
              <IconButton value={file.id} onClick={handleFilesClick} size="small" color="inherit">
                <PlayArrowIcon />
              </IconButton>
            </Box>
            <Box ml={2} border={1} borderRadius={8}>
              <IconButton href={file.filepath} target="_blank" size="small" color="inherit">
                <GetAppIcon />
              </IconButton>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    header: () => ({
      fontWeight: 400,
      paddingBottom: theme.spacing(2)
    }),
    squareIcon: {
      borderRadius: 8
    }
  }));

export default AttemptFiles;
